<template>
  <vjs-modal v-bind="$options.propsData"
             icon="la la-list"
             :title="title ? title : `Select a ${entityType}`">
    <template slot="body-content">
      <multiselect
        v-model="selected_entity"
        :options="entity_list"
        :placeholder="placeholder"
        :track-by="msTrackBy"
        :label="msLabel" />
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="close">
        Confirm
      </b-button>
      <b-button variant="ss-cancel" @click="close">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `entity-selection-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    entities: {
      type: Array,
      required: false,
      default: null,
    },
    endpoint: {
      type: String,
      required: false,
      default: null,
    },
    entityType: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: ``,
    },
    mapFunction: {
      type: Function,
      required: false,
      default: arg => arg,
    },
    msTrackBy: {
      type: String,
      required: false,
      default: null,
    },
    msLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    selected_entity: null,
    wrapper_height: `auto`,
  }),
  asyncComputed: {
    entity_list: {
      async get() {
        if (!this.nullish(this.endpoint)) {
          try {
            const res_data = (await axios.get(this.endpoint)).data;
            return this.fallback(this.mapFunction(res_data?.data), []);
          } catch (err) {
            window.handleAxiosError(err);
            return [];
          }
        } else {
          return this.entities ?? [];
        }
      },
      default: [],
    },
  },
  methods: {
    close() {
      this.close_data.selected_entity = this.selected_entity;
      this.complete();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v--modal) {
  overflow: visible;
}

:deep(.multiselect__content-wrapper) {
  position: static;
  border-bottom: 1px solid #e8e8e8;
}
</style>
